module.exports = __webpack_public_path__ + "static/media/slider-small-4.43c718cb.jpg";